module.exports = __webpack_public_path__ + "static/x4c-1dba50aeb963c7154f91e461a50ac49c.png";